import { DialogComponent } from "@syncfusion/ej2-react-popups";
import { FC } from "react";

interface IStopJobModal {
  open: boolean;
  onStopJob: (jobNumber: string, operation: string) => void;
  onClose: () => void;
  user: string;
  jobNumber: string;
  operation: string;
}

export const StopJobModal: FC<IStopJobModal> = ({
  open,
  onStopJob,
  onClose,
  user,
  jobNumber,
  operation,
}) => {
  const dialogHeader = "CSM Shopfloor";

  const buttons = [
    {
      buttonModel: {
        content: "Yes",
        cssClass: "e-flat",
        isPrimary: true,
      },
      click: () => {
        onStopJob(jobNumber, operation);
      },
    },
    {
      buttonModel: {
        content: "No",
        cssClass: "e-flat",
      },
      click: () => {
        onClose();
      },
    },
  ];

  const firstPosition = { X: 400, Y: 100 };

  return (
    <DialogComponent
      width="400px"
      close={onClose}
      header={dialogHeader}
      visible={open}
      showCloseIcon={true}
      buttons={buttons}
      position={firstPosition}
      isModal
    >
      {user}, are you sure that you want to stop job {jobNumber} operation '
      {operation}'?
    </DialogComponent>
  );
};
